import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { FeedbackDialog } from "../components/organisms/FeedbackDialog";

interface FeedbackContextValue {
  /** Opens the Send feedback dialog (mounted once, here). */
  openFeedback: () => void;
}

const FeedbackContext = createContext<FeedbackContextValue>({ openFeedback: () => undefined });

export const useFeedback = () => useContext(FeedbackContext);

/** Owns the one Send feedback dialog; any menu calls `openFeedback`. */
export const FeedbackProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openFeedback = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ openFeedback }), [openFeedback]);
  return (
    <FeedbackContext.Provider value={value}>
      {children}
      <FeedbackDialog open={open} onClose={close} />
    </FeedbackContext.Provider>
  );
};
